// extracted by mini-css-extract-plugin
export default {"teaser":"Pvtux91A","mobile":"mobile","image":"U2qSQemn","headline":"aTVYPe37","info":"iVqi2E8_","loader":"ItalesbV"};